import { StateSchema } from 'app/config/storeConfig/types';
import { RentalItem } from 'entities/RentalItem';

export const getSelectedRentalItems = (state: StateSchema): RentalItem[] => state.createContractModal.rentalItems;
